import { DetailsCard, PlanTable } from '../../shared/PlanDetails';

export interface PlanComparisonSectionProps {
  /**
   * When false, omits the Pediatrics column/cards (e.g. add-on upgrade flow
   * when no account member is pediatrics-age or on a Pediatrics plan).
   */
  showPediatrics?: boolean;
}

export function PlanComparisonSection({
  showPediatrics = true,
}: PlanComparisonSectionProps) {
  return (
    <div className='bg-sh-paper w-full'>
      <div className='mx-auto w-full max-w-[1400px] px-4 py-[60px]'>
        <div className='hidden lg:block'>
          <PlanTable showPediatrics={showPediatrics} />
        </div>
        <div className='flex flex-col gap-[40px] rounded-4xl bg-white p-[16px] lg:hidden'>
          <div className='flex flex-col items-center gap-[24px] text-center'>
            <h1 className='text-sh-dark-gray font-serif text-[27px] leading-[115%] font-light'>
              Compare Sollis Memberships
            </h1>
          </div>
          <DetailsCard plan='Signature' />
          <DetailsCard plan='Platinum' />
          {showPediatrics ? <DetailsCard plan='Pediatrics' /> : null}
        </div>
      </div>
    </div>
  );
}
